export const normalizePhoneInput = (
  rawInput: string,
  countryCode: string,
): string => {
  const cleaned = rawInput.replace(/[^\d+]/g, "");

  let digits = cleaned.startsWith("+")
    ? `+${cleaned.slice(1).replace(/\D/g, "")}`
    : countryCode + cleaned.replace(/\D/g, "");

  // Специальный кейс для автозаполнения и вставок
  if (
    ((countryCode === "+7" && digits.startsWith("+78")) ||
      (countryCode === "+40" && digits.startsWith("+400"))) &&
    digits.length > 5
  ) {
    digits = `${countryCode}${digits.slice(countryCode.length + 1)}`;
  }

  return digits;
};

export const formatByMask = (
  value: string,
  mask: string,
  countryCode: string,
): string => {
  const normalizedValue = value.startsWith("+")
    ? `+${value.slice(1).replace(/\D/g, "")}`
    : countryCode + value.replace(/\D/g, "");

  const digitsOnly = normalizedValue.replace(/\D/g, "");
  const countryCodeDigits = countryCode.replace("+", "");
  const maxDigits = mask.split("").filter((c) => c === "#").length;

  const startsWithCountryCode = digitsOnly.startsWith(countryCodeDigits);

  const rawDigits = startsWithCountryCode
    ? digitsOnly.slice(countryCodeDigits.length)
    : digitsOnly;

  const limitedRawDigits = rawDigits.slice(0, maxDigits);

  let result = "";
  let digitIndex = 0;

  for (const char of mask) {
    if (char === "#") {
      if (digitIndex < limitedRawDigits.length) {
        result += limitedRawDigits[digitIndex++];
      } else {
        result += "_";
      }
    } else {
      result += char;
    }
  }

  return result;
};

export const calculateCursorPosition = ({
  caretBeforeChange,
  maskedValue,
  defaultPosition,
  direction,
}: {
  caretBeforeChange: number;
  maskedValue: string;
  defaultPosition: number;
  direction: "forward" | "backward";
}): number => {
  if (/\d/.test(maskedValue[caretBeforeChange] ?? "")) {
    return caretBeforeChange;
  }

  if (direction === "backward") {
    // удаление — ищем ближайший _ влево
    for (let i = caretBeforeChange - 1; i >= defaultPosition; i--) {
      if (maskedValue[i] === "_") {
        return i;
      }
    }
  } else {
    // ввод — ставим курсор после следующего _
    for (let i = caretBeforeChange; i < maskedValue.length; i++) {
      if (maskedValue[i] === "_") return i;
    }
    // если всё заполнено — в конец
  }

  for (let i = maskedValue.length - 1; i >= 0; i--) {
    if (/\d/.test(maskedValue[i] ?? "") && i > defaultPosition) {
      return i + 1;
    }
  }

  return caretBeforeChange > defaultPosition
    ? caretBeforeChange
    : defaultPosition;
};
